import React, { Component } from 'react';
import axios from 'axios';
import { getApiHeader } from '../../../../utils/CommonFunctions';
import swal from '@sweetalert/with-react';
import { withRouter } from "react-router-dom";
import PageLoader from '../../../Loader/loader';
import ErrorMsg from '../../../public/errorMsg';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class Plan extends Component {

    constructor(props) {
        super(props);
        let gridClass = (this.props.from === 'activation') ? 'col-lg-6' : 'col-lg-4';
        this.state = {
            plan: [],
            loading: false,
            gridClass: gridClass,
            planSelected: false,
            iddSelected: false,
            plan_reference_number: null,
            plan_after_confirmation: null,
            btn_disable: { 'type0': false, 'type1': false, 'type2': false, 'type3': false },
            recharge_session: null,
            showBonus: 0,
            isCredit: 0,
            selectedPlan: null
        };

        // set & get session for recharge attempt 22-04-22
        const rSession = sessionStorage.getItem('rechargeSession');
        if (rSession == null) {
            const rSession = new Date().getTime();
            sessionStorage.setItem('rechargeSession', rSession);
        }
        if ((this.props.from) && (this.props.from === 'activation')) {
            const isCreditSession = sessionStorage.getItem('isCredit');
            if (isCreditSession == null) {
                this.state.isCredit = 0;
               
            } else {
                this.state.isCredit = isCreditSession;
               
            }
        } else {
            this.state.isCredit = 0;
        }
    }

    componentDidMount = () => {

      
        if ((this.props.from === 'activation') || (this.props.from === 'add-mobile-plan')) {
            if (sessionStorage.getItem("showBonus")) {
                this.setState({ showBonus: sessionStorage.getItem("showBonus") });
            }
        }
       
        if (this.props.referenceNumberApplied === true) {
            let plans = [this.props.plan]
            console.log("this.props.plan====>", plans)
            this.setState({ plan: plans, gridClass: 'col-lg-6 plan-center', plan_reference_number: this.props?.plan_reference_number });
            if (sessionStorage.getItem("showBonus")) {
                this.setState({ showBonus: sessionStorage.getItem("showBonus") });
            }
        } else if (this.props.plan) {
            this.setState({ plan: this.props.plan });
        }

    }

    componentWillReceiveProps = (nextProps) => {
        if (this.props.selectedPlan !== nextProps.selectedPlan) {
            if (nextProps.type === 'idd') {
                this.setState({ iddSelected: nextProps.selectedPlan });
            }
            if (nextProps.type === 'plan') {
                this.setState({ planSelected: nextProps.selectedPlan });
            }
        }
        if (this.props.plan !== nextProps.plan) {
            if (nextProps.plan !== null) {
                this.setState({ plan: nextProps.plan });
            }
        }
    }

    rechargeConfirm = async (plan) => {

     
        const rSession = sessionStorage.getItem('rechargeSession');
        if (rSession == null) {
            const rSession = new Date().getTime();
            sessionStorage.setItem('rechargeSession', rSession);
        }
        this.state.recharge_session = rSession;

        this.setState({ btn_disable: { ['type' + plan.is_bolt]: true } });
        let plan_id = plan.plan_id;
        this.setState({ loading: true });
        let headers = await getApiHeader();
        let params = {
            'payment_method': 'Card',
            'plan_id': plan_id,
            'mobile_number': this.props.mobileNumber,
            recharge_session: this.state.recharge_session
        }
        let response = null;
        try {
            if (this.props.from == 'recharge-a-friend') {
                let param = {
                    ...params,
                    activation_id: this.props.activation_id
                }
                response = await axios.post(`${SERVER_URL}recharge/friend`, param, { headers });
            } else {
                console.log(params);
                response = await axios.post(`${SERVER_URL}recharge/own-number`, params, { headers });
            }
            
            this.setState({ loading: false });
            swal({
                text: response.data.message,
                icon: "success"
            })
                .then(() => {
                    this.props.history.push("/home");
                });
        } catch (err) {
           
            this.setState({ loading: false });
            if (err) {
                let errorMessage = '';
                if (err.response && err.response.data && err.response.data.message) {
                   
                    if (typeof (err.response.data.message) === 'object') {
                        swal({
                            title: "Error",
                            content: <ErrorMsg message={err.response.data.message} />,
                            icon: "error"
                        });
                    } else {
                        errorMessage = err.response.data.message;
                        if (err.response.data.status == 422) {
                            swal({
                                title: 'Recharge Error',
                                text: errorMessage,
                                icon: "error"
                            }).then(() => {
                                this.props.history.push("/MyPayments");
                            });
                        } else {
                            swal(errorMessage, "error");
                            swal({
                                title: errorMessage,
                                icon: "warning"
                            }).then(() => {
                                this.props.history.push("/MyPayments");
                            });
                        }

                    }
                } else {
                    errorMessage = err;
                    swal(errorMessage, err);
                }
            }
        }
    }

    recharge = async (plan) => {
        let plan_id = plan.plan_id;
        if ((this.props.from === 'activation') || (this.props.from === 'add-mobile-plan')) {
            this.selectPlan(plan);
        } else {
          
            if (this.props.mobileNumber != null && this.props.activeStatus == '1') {
                var balanceMsg = "";
                if (this.props.from == 'recharge' || this.props.from == 'recharge-a-friend') {
                    this.setState({ loading: true });
                    let headers = await getApiHeader();
                    let params = {
                        plan_id: plan_id,
                        mobile_number: this.props.mobileNumber,
                        recharge_session: this.state.recharge_session,
                        recharge_from: this.props.from
                    }

                    await axios.post(`${SERVER_URL}recharge-popup/data-bank-balance`, params, { headers })
                        .then((response) => {
                            console.log('recharge-popup ==>', response)
                            if (response !== undefined) {
                                if (response.status == 200) {
                                    if (response.data !== undefined && response.data != null && response.data != '') {
                                        balanceMsg = response.data.message;
                                    } else {
                                        balanceMsg = "";
                                    }
                                }
                            }
                            this.setState({ loading: false });
                        })
                        .catch((error) => {
                            this.setState({ loading: false });
                           
                            balanceMsg = "";
                        });
                }


                if (this.props.from == 'guest-recharge') {
                    this.setState({ loading: true });
                    let headers = await getApiHeader();
                    let params = {
                        plan_id: plan_id,
                        mobile_number: this.props.mobileNumber,
                        session_id: "from-guest-recharge"
                     
                    }

                    await axios.post(`${SERVER_URL}guest-recharge-data-bank-balance`, params, { headers })
                        .then((response) => {
                            console.log('recharge-popup ==>', response)
                            if (response !== undefined) {
                                if (response.status == 200) {
                                    if (response.data !== undefined && response.data != null && response.data != '') {
                                        balanceMsg = response.data.message;
                                    } else {
                                        balanceMsg = "";
                                    }
                                }
                            }
                            this.setState({ loading: false });
                        })
                        .catch((error) => {
                            this.setState({ loading: false });
                            //console.log('error ==>', error.response)
                            balanceMsg = "";
                        });
                }


                if (balanceMsg == "") {
                    swal({
                        buttons: {
                            cancel: true,
                            confirm: { text: 'Yes' },
                        },
                        text: "Would you like to proceed with this recharge for " + this.props.mobileNumber + "?",
                        dangerMode: true,
                    })
                        .then(proceed => {
                            console.log('error ==>', proceed)
                            if (proceed) {

                                if (this.props.doubleDataPlan != null && this.props.doubleDataPlan != plan_id) {

                                    swal({
                                        icon: "warning",
                                        buttons: {
                                            confirm: "Yes, Proceed",
                                            cancel: "No, Select the " + this.props.doubleDataPlanName
                                        },
                                        text: "You are currently on an offer plan. If you change your plan now, the offer will be cancelled.",
                                        dangerMode: true,
                                    })
                                        .then(proceed => {
                                            console.log('error ==>', proceed)
                                            if (proceed) {

                                                // this.state({plan_after_confirmation: plan}, ()=>{

                                                if (this.props.from == 'guest-recharge') {
                                                    this.selectPlan(plan);
                                                    return;
                                                } else {
                                                    this.rechargeConfirm(plan);
                                                }

                                                // });

                                            }
                                        });

                                } else {


                                    if (this.props.from == 'guest-recharge') {
                                        this.selectPlan(plan, this.props.doubleDataPlan);
                                        return;
                                    } else {
                                        this.rechargeConfirm(plan);
                                    }


                                }

                            }

                        });
                } else {
                    swal({
                        icon: "warning",
                        buttons: {
                            cancel: true,
                            confirm: { text: 'Yes' },
                        },
                        text: balanceMsg + "\n Would you like to proceed with this recharge for " + this.props.mobileNumber + "?",
                        dangerMode: true,
                    })
                        .then(proceed => {
                            console.log('error ==>', proceed)
                            if (proceed) {

                                if (this.props.doubleDataPlan != null && this.props.doubleDataPlan != plan_id) {

                                    swal({
                                        icon: "warning",
                                        buttons: {
                                            confirm: "Yes, Proceed",
                                            cancel: "No, Select the " + this.props.doubleDataPlanName
                                        },
                                        text: "You are currently on an offer plan. If you change your plan now, the offer will be cancelled.",
                                        dangerMode: true,
                                    })
                                        .then(proceed => {
                                            console.log('error ==>', proceed)
                                            if (proceed) {

                                                // this.state({plan_after_confirmation: plan}, ()=>{

                                                if (this.props.from == 'guest-recharge') {
                                                    this.selectPlan(plan);
                                                    return;
                                                } else {
                                                    this.rechargeConfirm(plan);
                                                }

                                                // });

                                            }
                                        });

                                } else {

                                    if (this.props.from == 'guest-recharge') {
                                        this.selectPlan(plan, this.props.doubleDataPlan);
                                        return;
                                    } else {
                                        this.rechargeConfirm(plan);
                                    }

                                }




                            }
                        });
                }


            } else {
                if (this.props.mobileNumber != null) {
                    if (this.props.activeStatus == '9') {
                        swal("Mobile Number " + this.props.mobileNumber + " has been disconnected.", "If you have any queries, please feel free to contact Telsim Customer Care through chat or email at support@telsim.com.au or call us at 1300-TELSIM.", "warning");
                    } else {
                        swal("Mobile Number " + this.props.mobileNumber + " is not active", "If you have any queries, please feel free to contact Telsim Customer Care through chat or email at support@telsim.com.au or call us at 1300-TELSIM.", "warning");
                    }
                }
            }
            //===============new================//
        }
    }


    selectPlan = async (plan, dplan_id = null) => {

        let plan_id = plan.plan_id;
        if (this.props.from == 'guest-recharge') {
            if (plan_id == null) {
                let msg = 'Select a plan first.';
                if (plan_id === false) {
                    let msg = 'Error in select plan';
                }
                swal(msg, "error");
            }
            this.props.goNextStep(plan_id, dplan_id);
            return;
           
        } else {
            let selectedPlan = await this.props.changePlan(plan, this.props.type);
            if (selectedPlan === plan_id) {
                if ((this.props.from) && (this.props.from === 'add-mobile-plan')) {
                    this.props.goNextStep(plan);
                } else {
                    this.props.goNextStep(plan_id);
                }
            } else {
                this.setState({ loading: false });
                let msg = 'Select a plan first.';
                if (selectedPlan === false) {
                    let msg = 'Error in select plan';
                }
                swal(msg, "error");
            }
            return;
        }

    }

    render() {
        return (
            <>
                {(this.state.loading === true) ? <PageLoader /> : null}
                <div className="row row-cols-1 row-cols-md-2 g-4">
                    {this.state.plan.length > 0 ? (
                        this.state.plan.map((plan, index) => (
                            <div className={`col plan_box  post-paid-plan_box ${this.state.gridClass} mb10`} key={plan.plan_id}>
                                <div className="position-relative" style={{ width: "100%" }}>
                                    <div className="card border-danger w-100 h-100">
                                        {plan.popular_status === "1" && <div className="ribbon">Popular</div>}

                                        <div className="card-header plan_header text-center" style={{ paddingTop: "13px", paddingBottom: "13px" }}>
                                            <h4 className="card-title m0">
                                                {plan?.plan_name ? plan?.plan_name : plan?.offerName} {plan?.plan_name?.includes("5G") ? "" : plan.plan_tag === "5G Plan" ? "- 5G" : ""}
                                            </h4>
                                        </div>

                                        <div className="card-header text-center" style={{ paddingTop: "13px", paddingBottom: "13px" }}>
                                            <h4 className="card-title m0">
                                                {plan.data}GB <span className="card-subtitle mb-2 fontSize18" style={{ fontWeight: 400, fontSize: '14px' }}> Data  </span> - {'   '}
                                                {plan?.amount > plan?.sell_amount ? (<span className="card-subtitle mb-2 fontSize18" style={{ fontWeight: 400, textDecoration: 'line-through', fontSize: '14px' }}>
                                                    ${plan?.amount}
                                                </span>) : null}
                                                <span className="card-subtitle mb-2 fontSize18" style={{ fontWeight: 600, color: "#C11D6C" }}>
                                                    {"   "} ${plan?.sell_amount}
                                                </span>
                                            </h4>
                                        </div>

                                        <div className="card-header text-center p-y-1" style={{ backgroundColor: '#ffffff' }}>
                                            <h5 className="card-subtitle">
                                                {plan.plan_title}
                                            </h5>
                                        </div>

                                        {plan.plan_sub_title && (
                                            <div className="card-header text-center p-y-1">
                                                <h5 className="card-subtitle">
                                                    {plan.plan_sub_title}
                                                </h5>
                                            </div>
                                        )}

                                        <div className="card-body">
                                            <ul className="feature_list">
                                                {/* <li>{plan.data}GB data.</li> */}

                                                {(plan.plan_detail || plan.post_paid_plan_detail || []).map((detail, i) => (
                                                    <li key={i}>{detail.description}</li>
                                                ))}

                                                {/* {plan.data_gifting_status === "1" && <li>Gift & Receive Data.</li>} */}
                                                {plan.data_gifting_status === "2" && <li>Receive Data.</li>}
                                                {plan.data_gifting_status === "3" && <li>Gift Data.</li>}
                                            </ul>
                                        </div>

                                        {/* IRR Country List Accordion */}
                                        {plan.ir_countries && typeof plan.ir_countries === 'object' && Object.keys(plan.ir_countries).length > 0 && (
                                            <div className="accordian_div">
                                                <div className="accordion customAccordian" id={`accordionIR_${index}`}>
                                                    <div className="card accordianCard b0">
                                                        <div className="card-header pxy20 accordianCardHeader" id={`headingIR_${index}`}>
                                                            <h2 className="mb-0">
                                                                <button
                                                                    className="btn btn-link btn-block text-left headerCollapse pxy20"
                                                                    type="button"
                                                                    data-toggle="collapse"
                                                                    data-target={`#collapseIR_${index}`}
                                                                    aria-expanded="false"
                                                                    aria-controls={`collapseIR_${index}`}
                                                                >
                                                                    <i className="fa fa-chevron-down whatElseInclude"></i> IR Country List
                                                                </button>
                                                            </h2>
                                                        </div>
                                                        <div
                                                            id={`collapseIR_${index}`}
                                                            className="collapse"
                                                            aria-labelledby={`headingIR_${index}`}
                                                            data-parent={`#accordionIR_${index}`}
                                                        >
                                                            <div className="card-body accordianCardBody post-paid-accordianCardBody">
                                                                {Object.keys(plan.ir_countries).map((key) => (
                                                                    <p key={key}>
                                                                        <i className="fa fa-check custom-plan-expanded"></i> {plan.ir_countries[key]}
                                                                    </p>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* IDD Country List Accordion */}
                                        {plan.idd_pack && plan.idd_pack.countries && (() => {
                                            try {
                                                const iddCountries = JSON.parse(plan.idd_pack.countries);
                                                return iddCountries.length > 0 ? (
                                                    <div className="accordian_div">
                                                        <div className="accordion customAccordian" id={`accordionIDD_${index}`}>
                                                            <div className="card accordianCard b0">
                                                                <div className="card-header pxy20 accordianCardHeader" id={`headingIDD_${index}`}>
                                                                    <h2 className="mb-0">
                                                                        <button
                                                                            className="btn btn-link btn-block text-left headerCollapse pxy20"
                                                                            type="button"
                                                                            data-toggle="collapse"
                                                                            data-target={`#collapseIDD_${index}`}
                                                                            aria-expanded="false"
                                                                            aria-controls={`collapseIDD_${index}`}
                                                                        >
                                                                            <i className="fa fa-chevron-down whatElseInclude"></i>  Country List
                                                                        </button>
                                                                    </h2>
                                                                </div>
                                                                <div
                                                                    id={`collapseIDD_${index}`}
                                                                    className="collapse"
                                                                    aria-labelledby={`headingIDD_${index}`}
                                                                    data-parent={`#accordionIDD_${index}`}
                                                                >
                                                                    <div className="card-body accordianCardBody post-paid-accordianCardBody">
                                                                        {iddCountries.map((country, i) => (
                                                                            <p key={i}>
                                                                                <i className="fa fa-check custom-plan-expanded"></i> {country}
                                                                            </p>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : null;
                                            } catch (error) {
                                                console.error("Invalid IDD countries JSON:", error);
                                                // return null;
                                            }
                                        })()}


                                        <div className="card-footer bg-transparent text-center" style={{ padding: "10px" }}>
                                            <button
                                                className="btn btn-danger"
                                                onClick={() => this.recharge(plan)}
                                            >
                                                {this.props.selectedPlan === plan.plan_id ? (
                                                    <>
                                                        <i className="fa fa-check" aria-hidden="true"></i> Selected
                                                    </>
                                                ) : (
                                                    'Select'
                                                )}
                                            </button>

                                            <div style={{ marginTop: "8px" }}>
                                                <a
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: "#C11D6C", textDecoration: "none" }}
                                                    href={process.env.REACT_APP_CRITICAL_IN_SUMMARY}
                                                >
                                                    Critical information summary
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div>No plans available.</div>
                    )}
                </div>

            </>
        );
    }

}

export default withRouter(Plan);